"use client";
import React, { useState } from "react";
import { Button } from "./ui/button.js";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet.js";
import { Menu } from "lucide-react";
import LoginDialog from "./LoginDialog";
import { mockCompanyData } from "./mock";
import "./Header.css";
import logo from "../../../assets/logo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const navItems = [
    { name: "Home", href: "#home" },
    { name: "Services", href: "#services" },
    { name: "Why Choose Us", href: "#why-choose" },
    { name: "How It Works", href: "#how-it-works" },
    { name: "About", href: "#about" },
    { name: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  return (
    <>
      <header className="headers">
        <div className="header-containers">
          {/* Logo */}
          <div className="logos">
            <img src={logo} alt="logo" />
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="nav-item"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Desktop Login Button */}
          <div className="login-desktop">
            <button
              onClick={() => setShowLogin((prev) => !prev)}
              className="login-button"
            >
              Login
            </button>
          </div>

          {/* Mobile Menu Button */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setIsOpen(true)}
                className="menu-button"
              >
                <Menu className="menu-icon" />
              </Button>
            </SheetTrigger>

            <SheetContent side="right" className="mobile-menu">
              <div className="mobile-menu-container">
                <div className="mobile-header">
                  <span className="company-name">{mockCompanyData.name}</span>
                </div>

                <nav className="mobile-nav">
                  <div className="mobile-nav-items">
                    {navItems.map((item) => (
                      <button
                        key={item.name}
                        onClick={() => scrollToSection(item.href)}
                        className="mobile-nav-item"
                      >
                        {item.name}
                      </button>
                    ))}
                  </div>
                </nav>

                <div className="mobile-login">
                  <Button
                    onClick={() => {
                      setShowLogin(true);
                      setIsOpen(false);
                    }}
                    className="login-button"
                  >
                    Login
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </header>

      <LoginDialog open={showLogin} onOpenChange={setShowLogin} />
    </>
  );
};

export default Header;
